import { c as _c } from "react/compiler-runtime";
import { List as MuiList, Paper } from '@mui/material';
import { styled } from '@classify/react-core-components/styles';
import ListItem from '../ListItem';
const PREFIX = 'List';
const classes = {
  outlined: `${PREFIX}-outlined`
};
const StyledPaper = styled(Paper)(({
  theme: {
    palette,
    shape
  }
}) => ({
  [`& .${classes.outlined}`]: {
    border: `1px solid ${palette.stroke}`,
    borderRadius: shape.borderRadius * 2
  }
}));
function List(t0) {
  const $ = _c(11);
  let otherProps;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      children: t1,
      elevation: t2,
      ...otherProps
    } = t0);
    $[0] = t0;
    $[1] = otherProps;
    $[2] = t1;
    $[3] = t2;
  } else {
    otherProps = $[1];
    t1 = $[2];
    t2 = $[3];
  }
  const children = t1 === undefined ? null : t1;
  const elevation = t2 === undefined ? 1 : t2;
  const t3 = elevation === 0 ? "outlined" : "elevation";
  let t4;
  if ($[4] !== children || $[5] !== otherProps) {
    t4 = <MuiList {...otherProps}>{children}</MuiList>;
    $[4] = children;
    $[5] = otherProps;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== elevation || $[8] !== t3 || $[9] !== t4) {
    t5 = <StyledPaper elevation={elevation} variant={t3} classes={classes}>{t4}</StyledPaper>;
    $[7] = elevation;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}
List.Item = ListItem;
export default List;